import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsTooltipModule } from '@frontend/ui/tooltip';
import { ContentImage } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BaseDetailsDataPoint } from '../../../../base-details/base-details.model';
import { SlabContent } from '../../models/slab-content';

@Component({
    selector: 'criteria-slab',
    templateUrl: './criteria-slab.component.html',
    styleUrl: './criteria-slab.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, DsButtonIcon, IconCustomComponent, DsTooltipModule, NgTemplateOutlet],
})
export class CriteriaSlabComponent {
    @Input() slabContent: SlabContent;
    @Input() rewardContent: BaseDetailsDataPoint;
    @Input() slabImage: ContentImage;
    @Input() isDisabled: boolean;
    @Output() onPopperChange = new EventEmitter<boolean>();
    isPopperOpen: boolean = false;
    dsComponents: DSComponents;

    constructor(private designSystemHelperService: DesignSystemHelperService) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }

    changePopper(event: any) {
        this.isPopperOpen = event?.isTooltipOpen;
        if (this.isPopperOpen) this.onPopperChange.emit(true);
    }
}
